import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Sidebar from "../../Components/Sidebar";
import { addNews } from "../../redux/actions/GalleryAndNews";
import { useDispatch } from "react-redux";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PageComponent from "../../Components/PageComponent";

function AddNews() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [publishDate, setPublishDate] = useState(new Date());
  const [description, setDescription] = useState("");
  const [imageFields, setImageFields] = useState([{ file: null }]);
  const [isSaving, setIsSaving] = useState(false);

  const dispatch = useDispatch();

  const handleImageUpload = (index, file) => {
    const updatedFields = [...imageFields];
    updatedFields[index].file = file;
    setImageFields(updatedFields);
  };

  const handleAddMore = () => {
    setImageFields([...imageFields, { id: Date.now(), file: null }]);
  };

  const handleRemoveField = (id) => {
    setImageFields(imageFields.filter((field) => field.id !== id));
  };

  const handleSave = async (e) => {
    e.preventDefault();
  
    if (!title || !description || imageFields.every((field) => !field.file)) {
      alert("Please fill in all required fields and upload at least one image.");
      return;
    }
  
    setIsSaving(true);
  
    // Create FormData object
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("date", publishDate.toISOString().split("T")[0]);
  
    // Append all files under the same key: "file"
    imageFields.forEach((field) => {
      if (field.file) {
        formData.append("file", field.file); // Same key for all files
      }
    });
  
    try {
      // Dispatch addNews action
      await dispatch(
        addNews(formData, () => {
          alert("News added successfully!");
          navigate("/gallery&News/list-news");
        })
      );
    } catch (error) {
      console.error("Failed to save news:", error);
      alert(`Error adding news: ${error.response?.data?.message || "Unknown error"}`);
    } finally {
      setIsSaving(false);
    }
  };
  
  
  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      <div className="flex-1 p-6 ml-64">
        <div className="mb-6">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Gallery & News</span>
          <span>/</span>
          <span className="text-black">News</span>
        </div>
         
        <div className="flex items-center mt-4 space-x-4">
            <button
              className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow hover:bg-[#6C0B67]"
              onClick={() => navigate("/gallery&News/add-news")}
            >
              Add New News
            </button>
            <button
              className="px-4 py-2 text-[#92288C] border border-[#92288C] rounded-md shadow hover:bg-gray-100"
              onClick={() => navigate("/gallery&News/list-news")}
            >
              List of News
            </button>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-bold">Add News</h2>
          <form onSubmit={handleSave}>
          <div className="space-y-6"> {/* Adjusted spacing between sections */}
  {/* Title and Publish Date */}
  <div className="flex space-x-4">
    <div className="flex-1">
      <label className="block text-gray-700">Title</label>
      <input
        type="text"
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
        placeholder="Enter title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
    </div>
    <div className="flex-1">
      <label className="block text-gray-700">Date (Publish Date)</label>
      <DatePicker
        selected={publishDate}
        onChange={(date) => setPublishDate(date)}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
      />
    </div>
  </div>

  {/* Description */}
  <div className="mb-2">
  <label className="block text-gray-700">Description</label>
  <div className="mt-2"> {/* Added margin to avoid overlap */}
    <ReactQuill
      value={description}
      onChange={setDescription} // ReactQuill directly provides the value
      
      placeholder="Enter description"
      className="h-[200px] mb-14"// Adjusted height for a better editing experience
      modules={{
        toolbar: [
          [{ header: [1, 2, 3, false] }], // Heading styles
          [{ font: [] }], // Font selection
          ["bold", "italic", "underline"], // Font styles
          [{ align: [] }], // Alignment options
          ["clean"], // Clear formatting
        ],
      }}
      formats={[
        "font",
        "header",
        "bold",
        "italic",
        "underline",
        "align",
      ]}
      theme="snow"
    />
  </div>
</div>


  {/* Image Upload Fields */}
  <div className="space-y-4"> {/* Added spacing between image upload fields */}
    {imageFields.map((field, index) => (
      <div key={field.id} className="flex items-center space-x-4">
        <div className="flex-1">
          <label className="block text-gray-700">Upload Image {index + 1} (Image size should 450px x 300px )</label>
          <div className="flex items-center mt-2 space-x-4">
            <input
              type="text"
              readOnly
              value={field.file ? field.file.name : ""}
              placeholder="No file selected"
              className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md cursor-not-allowed focus:outline-none"
            />
            <label
              htmlFor={`upload-image-${field.id}`}
              className="px-4 py-2 text-white bg-[#92288C] rounded-md shadow cursor-pointer hover:bg-[#6C0B67]"
            >
              Browse Image
            </label>
            <input
              type="file"
              id={`upload-image-${field.id}`}
              accept="image/*"
              onChange={(e) => handleImageUpload(index, e.target.files[0])}
              className="hidden"
            />
            {imageFields.length > 1 && (
              <button
                type="button"
                onClick={() => handleRemoveField(field.id)}
                className="text-sm text-red-600 hover:underline"
              >
                Remove
              </button>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* Add More Button */}
  <button
    type="button"
    onClick={handleAddMore}
    className="mt-4 text-sm text-[#92288C] hover:underline"
  >
    Add more
  </button>
</div>



            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="button"
                onClick={() => navigate("/gallery-news")}
                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSaving}
                className={`px-4 py-2 text-white rounded-md ${
                  isSaving
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#92288C] hover:bg-[#6C0B67]"
                }`}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default AddNews;
